import React, { useContext } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Checkbox from 'commonComponents/forms/Checkbox/Checkbox';
import { FormContext } from 'hocHelpers/withContactForm';
import styles from './SubmitFields.module.scss';

const SubmitFields = ({ submit, sitekey }) => {
  const { user, reRef, contactPage } = useContext(FormContext);

  return (
    <>
      { !user && !contactPage && <AgreeTermsCheckbox /> }
      { submit && <Submit { ...submit } /> }
      <ReCAPTCHA
        sitekey={ sitekey }
        size="invisible"
        ref={ reRef }
      />
    </>
  );
};
 
const AgreeTermsCheckbox = () => {
  const { agree } = useContext(FormContext);

  if (!agree) return null;

  const { text, links } = agree.label;

  return (
    <Checkbox
      name="accepted_terms"
      required={ true }
      { ...agree }
    >
      <span>{ text }&nbsp;</span>
      <a href='/terms'>{ links[0] }</a>
      <span>&nbsp;&amp;&nbsp;</span>
      <a href='/privacy-policy'>{ links[1] }</a>.
    </Checkbox>
  );
};
 
const Submit = ({ label }) => {
  return (
    <p className={ styles.submitButton }>
      <button type="submit">{ label }</button>
    </p>
  );
};

export default SubmitFields;
